module.exports = __webpack_public_path__ + "media/images/icons/events-count-c311943c2dcebdfc1f32e4f4b67ae99d.svg";